import { ReactElement, useCallback, useMemo } from 'react';
import { useCurrentURL } from '../../../hooks/useCurrentURL';
import { TProviders } from '../../../IAuthProviders.types';
import { IAuthProviderUiProps } from '../../../IAuthProviderUiProps.types';
import { useVippsProvider } from '../services/useVippsProvider';
import { VippsButton } from './VippsButton';

export type IVippsLoginProps = IAuthProviderUiProps & {
  /** @deprecated */
  label?: 'login' | 'continue'; // backward compatible
};

export const VippsLogin = ({
  action,
  language = 'nb',
  label = 'login',
  axoApiUrl,
  onStart,
  onSuccess,
  onError,
  shouldClearHash,
}: IVippsLoginProps): ReactElement => {
  useVippsProvider({ onSuccess, onError, shouldClearHash });

  const currentURL = useCurrentURL();

  const redirectUri = useMemo(() => {
    const url = new URL(currentURL.href);

    if (!url.searchParams.has('provider'))
      url.searchParams.set('provider', 'vipps');

    return url.href;
  }, [currentURL]);

  const authUrl = useMemo(
    () =>
      `${axoApiUrl}/auth/provider/vipps/auth?redirect_uri=${encodeURIComponent(
        redirectUri
      )}`,
    [axoApiUrl, redirectUri]
  );

  const handleLoginStart = useCallback(() => {
    onStart?.(TProviders.Vipps);
  }, [onStart]);

  const hasAction = action !== undefined;

  return (
    <VippsButton
      action={hasAction ? action : label}
      language={language}
      onClick={handleLoginStart}
      href={authUrl}
      data-testid={'vipps-login'}
    />
  );
};
